export default {
  pageTitle: '活动管理',
  pageDesc: '管理当前公司下的会议/活动信息；须在「公司空间」下操作。',
  personalWorkspaceAlert: '当前为个人空间，活动管理需切换到公司空间并选择公司后再使用。',
  searchPlaceholder: '搜索活动名称 / 地点 / 简介',
  addEvent: '新增活动',
  editEvent: '编辑活动',
  emptyTable: '暂无活动',
  eventName: '活动名称',
  requiresRegistration: '需要报名',
  registrationApproval: '报名审核',
  approvalRequired: '需审核',
  approvalAuto: '免审核',
  eventCity: '活动省市',
  eventAddress: '详细地点',
  eventIntro: '会议简介',
  creator: '创建人',
  createdAt: '创建时间',
  namePlaceholder: '请输入活动名称',
  registrationNeedsApproval: '报名需审核',
  cityPlaceholder: '如：广东省广州市',
  citySelectPlaceholder: '请选择省/市',
  addressPlaceholder: '请输入会议详细地址',
  introPlaceholder: '请输入会议简介',
  nameRequired: '请输入活动名称',
  switchCompanyFirst: '请先切换到公司空间',
  createSuccess: '活动创建成功',
  updateSuccess: '活动更新成功',
  loadFailed: '活动详情加载失败，请稍后重试',
  deleteConfirmTitle: '删除确认',
  deleteConfirmMessage: '确定要删除活动「{name}」吗？',
  deleteConfirmOk: '确定删除',
  deleteSuccess: '删除成功',
  eventCreateGate: {
    needEventFirst: '请先完成「活动信息」保存以创建活动，再继续本页操作。'
  },
  wizardNav: {
    primaryAria: '活动向导一级导航',
    primaryEvent: '活动',
    primaryRegistration: '报名',
    backToList: '返回活动列表',
    close: '关闭',
    groupBasic: '基础设置',
    groupRegistration: '报名相关',
    groupMore: '更多',
    eventInfo: '活动信息',
    location: '地点设置',
    registration: '报名设置',
    registrationForm: '报名表单',
    share: '分享设置',
    microsite: '微站 / 装修',
    schedule: '会议日程'
  },
  eventInfo: {
    pageTitle: '活动信息',
    lastSaved: '最后保存时间',
    helpTitle: '说明',
    helpDesc: '在此页填写活动基本信息、地点与报名设置；活动省市请通过省/市级联选择。'
  },
  eventLocation: {
    pageTitle: '地点设置',
    helpTitle: '说明',
    helpDesc: '设置活动举办的城市与详细地址，将展示在报名页与活动详情中。'
  },
  eventRegistration: {
    pageTitle: '报名设置',
    helpTitle: '说明',
    helpDesc: '开启报名后，用户可提交报名信息；若需审核，请开启「报名需审核」。'
  },
  schedule: {
    pageTitle: '会议日程',
    helpTitle: '说明',
    helpDesc: '管理活动下的单场会议/议程；可按日期筛选，支持名称与地点搜索。',
    add: '添加',
    edit: '编辑',
    copy: '复制',
    delete: '删除',
    searchPlaceholder: '会议名称/地点',
    filterDatePlaceholder: '选择日期',
    colName: '会议名称',
    colTime: '开始-结束时间',
    colLocation: '地点',
    colIntro: '会议简介',
    formStart: '会议开始',
    formEnd: '会议结束',
    formRegion: '会议区域',
    formAddress: '详细地址',
    regionPlaceholder: '请选择省/市/区',
    addressPlaceholder: '请输入详细地址',
    introTip: '如需[装修]会议详情页面，简介的内容会在装修中展示，请选填',
    submitAdd: '添加日程',
    submitEdit: '保存日程',
    backToList: '返回列表',
    formHelpDesc: '填写单场会议的名称、时间、地点与简介；带 * 为必填项。',
    nameRequired: '请输入会议名称',
    startRequired: '请选择会议开始时间',
    endRequired: '请选择会议结束时间',
    endAfterStart: '结束时间须晚于开始时间',
    regionRequired: '请选择会议区域',
    addressRequired: '请输入详细地址',
    namePlaceholder: '请输入会议名称',
    introPlaceholder: '请输入会议简介',
    createSuccess: '会议添加成功',
    updateSuccess: '会议更新成功',
    saveFailed: '保存失败，请稍后重试',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    deleteConfirmTitle: '删除确认',
    deleteConfirmMessage: '确定要删除选中的 {count} 条会议日程吗？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    loadFailed: '加载会议日程失败'
  },
  eventTime: '活动时间',
  timeStartPlaceholder: '开始时间',
  timeEndPlaceholder: '结束时间',
  list: {
    createActivity: '创建活动',
    topForm: '表单管理',
    topItinerary: '行程预设',
    topPayment: '支付管理',
    topAudit: '名单审核',
    topAssociation: '报名关联',
    allActivities: '所有活动({count})',
    advancedFilter: '高级筛选',
    searchNameOnly: '搜索活动名称',
    countdown: '倒计时',
    share: '分享',
    sort: '排序',
    qrShare: '二维码分享',
    addressUnset: '暂未设置地点',
    statusUnset: '—',
    statusEnded: '已结束',
    statusOngoing: '进行中',
    countdownDays: '{days}天',
    opActivity: '活动',
    opSchedule: '日程',
    opShare: '分享',
    opDecorate: '装修',
    opPayment: '支付',
    opRegistration: '报名',
    opCheckin: '签到',
    opSeating: '座位',
    opDelete: '删除'
  }
}
